export const saveInStorage = (key, data) => {
  const shouldSave =
    localStorage.getItem("@online-editor/save-data") !== "false";
  if (shouldSave) {
    localStorage.setItem(`@online-editor/${key}`, data);
  }
};

export const saveInStorageAlways = (key, data) => {
  localStorage.setItem(`@online-editor/${key}`, data);
};

// Removes all English letters from a string
export function removeEnglish(value) {
  return typeof value === 'string' ? value.replace(/[A-Za-z]/g, '') : value;
}

// Dynamically filters input and sets a form field value
export function filterAndSetField(form, fieldName, value, filterFn = removeEnglish) {
  const filtered = filterFn(value);
  form.setFieldsValue({ [fieldName]: filtered });
}
